export default function ForgotPasswordScreen() {
  return null;
}